import { render, staticRenderFns } from "./PopularExams.vue?vue&type=template&id=57751c74&scoped=true"
import script from "./PopularExams.vue?vue&type=script&lang=js"
export * from "./PopularExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57751c74",
  null
  
)

export default component.exports